import './styles/transitionner.css'
import PropTypes from 'prop-types';

/**
 * Component representing a transition effect.
 * @param {boolean} isAnimate - Indicates whether the animation is active.
 * @param {boolean} isAppearing - Indicates whether the transition is appearing.
 * @returns {JSX.Element} The Transitionner component.
 */
export default function Transitionner({isAnimate, isAppearing}) {
    return (
        <div className={`backgroundEffect${isAnimate ? " active" : ""}${isAppearing ? " appear" : ""}`}>
            <div className="col">Developpeur - Developpeur - Developpeur - Developpeur - Developpeur - Developpeur - Developpeur - Developpeur</div>
            <div className="col">Front-End - Front-End - Front-End - Front-End - Front-End - Front-End - Front-End - Front-End - Front-End</div>
            <div className="col">Français - Français - Français - Français - Français - Français - Français - Français - Français - Français</div>
            <div className="col">Junior - Junior - Junior - Junior - Junior - Junior - Junior - Junior - Junior - Junior - Junior - Junior</div>
            <div className="col">Creatif - Creatif - Creatif - Creatif - Creatif - Creatif - Creatif - Creatif - Creatif - Creatif - Creatif</div>
            <div className="col">Design - Design - Design - Design - Design - Design - Design - Design - Design - Design - Design - Design</div>
            <div className="col">Conception - Conception - Conception - Conception - Conception - Conception - Conception - Conception - Conception</div>
        </div>
    );
};

// PropTypes for the Transitionner component
Transitionner.propTypes = {
    isAnimate: PropTypes.bool.isRequired,
    isAppearing: PropTypes.bool.isRequired,
};
